/* @flow */
import * as React from 'react';
import pluralize from 'pluralize';

import Group from 'entities/Group';
import GroupAvatarWithText from 'groups/components/GroupAvatarWithText';
import MediaObject from 'components/MediaObject';
import RemoveClassConfirmDialog from 'groups/components/RemoveClassConfirmDialog';
import MenuButton from 'components/MenuButton';
import Glyph from 'components/Glyph';
import { mountModal } from 'lib/modal';
import Menu from 'components/Menu';
import MenuItem from 'components/MenuItem';
import Icon from 'components/Icon';
import Button from 'components/Button';

import './styles/OwnedClassesListItem.scss';

export class OwnedClassesListItem extends React.Component<{
  ownedClass: Group,
  onActionCompletion: () => void,
}> {
  showArchiveModal = () => {
    const { ownedClass, onActionCompletion } = this.props;
    const unmountModal = mountModal(
      <RemoveClassConfirmDialog
        group={ownedClass}
        onActionCompletion={() => {
          if (onActionCompletion) {
            onActionCompletion();
          }
          if (unmountModal) {
            unmountModal();
          }
        }}
      />,
      this
    );
  };

  renderMenu() {
    return (
      <Menu>
        <MenuItem onClick={this.showArchiveModal}>
          <Icon
            className="OwnedClassesListItem-menuItem-icon"
            name="archive"
            size="medium"
            color="eclipse"
          />
          Archive class
        </MenuItem>
      </Menu>
    );
  }

  render() {
    const { ownedClass } = this.props;
    const memberCount = ownedClass.getMembershipsCount();

    return (
      <MediaObject center figure="right" gutter="xsmall" className="OwnedClassesListItem">
        <GroupAvatarWithText
          group={ownedClass}
          subtextAppend={`${memberCount} ${pluralize('member', memberCount)}`}
        />
        <div className="OwnedClassesListItem-actions">
          {ownedClass.hasRosterSource() && (
            <Button
              aria-label="Linked Remind classes are updated directly from your school’s database."
              className="OwnedClassesListItem-link"
              tooltip="Linked Remind classes are updated directly from your school’s database."
              tooltipPlacement="top"
              color="shamrock"
              level="icon">
              <Glyph name="link" size="large" />
            </Button>
          )}
          {ownedClass.canEdit() && (
            <MenuButton
              className="OwnedClassesListItem-menuButton"
              alignment="right"
              placement="bottom"
              menu={this.renderMenu()}
              size="small"
              level="icon">
              <Glyph name="ellipses" size="large" solo />
            </MenuButton>
          )}
        </div>
      </MediaObject>
    );
  }
}

export default OwnedClassesListItem;
